import { ActionButtonVariant } from '../../../../components/ActionButton/styled'
import { actions } from '../../../../redux'
import { MemberProps, MemberReturn } from '../../../../types'
import { OTHER_FAMILY_RELATIONSHIP } from '../useAddMemberStep'

export const useChild = (props: MemberProps & { childIndex: number }): MemberReturn => {
  const { t, dispatch, formValues, fullName, childIndex } = props

  const declarations = (formValues?.children[childIndex]?.items as any) || []
  const existingChild = formValues?.children?.[childIndex]
  const initialRelationshipCustom = existingChild?.familyRelationshipCustom ?? ''
  const initialRelationshipId = initialRelationshipCustom
    ? OTHER_FAMILY_RELATIONSHIP
    : (existingChild?.familyRelationshipId ?? '')

  const handleAddDeclaration = (values: any) => {
    dispatch(
      actions.declaration.appendChildDeclarationItem({
        childIndex,
        item: {
          ...values,
          id: declarations.length,
        },
      })
    )
  }

  const handleUpdateDeclaration = (i: number, values: any) => {
    dispatch(
      actions.declaration.updateChildDeclarationItem({
        childIndex,
        itemIndex: i,
        item: values,
      })
    )
  }

  const handleDeleteDeclaration = (i: number) => {
    dispatch(actions.declaration.removeChildDeclarationItem({ childIndex, itemIndex: i }))
  }

  const handleResetDeclaration = () => {
    dispatch(actions.declaration.resetChildren())
  }

  const handleAddMember = (values: any) => {
    dispatch(
      actions.declaration.setChild({
        index: formValues.children.length,
        child: values,
      })
    )
  }

  return {
    declarations,
    addDeclaration: handleAddDeclaration,
    updateDeclaration: handleUpdateDeclaration,
    deleteDeclaration: handleDeleteDeclaration,
    resetMember: handleResetDeclaration,
    addMember: handleAddMember,
    addMemberInitialValues: {
      hasMemberToDeclare: '0',
      civility: '',
      lastName: '',
      firstName: '',
      familyRelationshipId: initialRelationshipId,
      familyRelationshipCustom: initialRelationshipCustom,
    },
    addAnotherChild: {
      text: t('declaration.form.addAnotherChild.text'),
      variant: ActionButtonVariant.secondary,
    },
    addDeclarationStepPartText: t('declaration.form.stepPart.childDeclaration'),
    addDeclarationLabel: t('declaration.from.addDeclaration.label.child', {
      name: fullName,
    }),
    declarationListStepPartText: t('declaration.form.stepPart.childDeclaration'),
    declarationListLabel: t('declaration.form.declarationList.label', {
      name: fullName,
      type: t('declaration.child'),
    }),
    addMemberStepPartText: t('declaration.form.stepPart.childDeclaration'),
    addMemberLabel: t('declaration.form.addMember.label.child'),
    typeOfAdd: 'child',
  }
}
